import React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
  useMasonryEngineActionEmitter,
} from '@leagueplatform/masonry-engine';
import {
  MasonryDeeplinkAction,
  MasonryDriverAction,
} from '@leagueplatform/masonry-renderers';

const RewardsProgramProgressCard = React.lazy(() =>
  import('@leagueplatform/health-journey').then((module) => ({
    default: module.RewardsProgramProgressCard,
  })),
);

type RewardProgramsCardProps = React.ComponentProps<
  typeof RewardsProgramProgressCard
>;

type RewardProgramsCardNodeActions = {
  onClick?: MasonryDriverAction;
};

type RewardProgramsCardNode = MasonryEngineNode<
  'rewardProgramsCard',
  RewardProgramsCardProps,
  RewardProgramsCardNodeActions
>;

export type RewardProgramsCardNodeRendererProps =
  MasonryEngineNodeRendererProps<RewardProgramsCardNode>;

export const RewardProgramsCard = (
  props: RewardProgramsCardNodeRendererProps,
) => {
  const { onClick, ...restProps } = props;

  const invokeAction = useMasonryEngineActionEmitter();
  const handleOnClick = React.useCallback(() => {
    if (onClick) invokeAction(onClick);
  }, [invokeAction, onClick]);

  return (
    <RewardsProgramProgressCard
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
      onClick={handleOnClick}
      cta={(onClick as MasonryDeeplinkAction).payload.url}
    />
  );
};
